import React from 'react'
import styles from './pending-area.styles'
import injectSheet from 'react-jss'
import Spinner from 'pobble-components/dist/spinner'
import classNames from 'classnames'

const PendingArea = ({ classes, className, spinnerParams, fadeIn }) => (
  <div
    className={classNames(classes.container, className, {
      [classes.fadeIn]: fadeIn
    })}>
    <Spinner {...spinnerParams} />
  </div>
)

export default injectSheet(styles)(PendingArea)
